import { gql } from 'graphql-tag';

import AffiliationCardBlockFragment from '@fragments/shared/AffiliationCardBlockFragment';
import ButtonBlockFragment from '@fragments/shared/ButtonBlockFragment';
import CollectionBlockFragment from '@fragments/shared/CollectionBlockFragment';
import ContentCardBlockFragment from '@fragments/shared/ContentCardBlockFragment';
import ContentFeedBlockFragment from '@fragments/shared/ContentFeedBlockFragment';
import EventPanelBlockFragment from '@fragments/shared/EventPanelBlockFragment';
import ExpertHighlightsBlockFragment from '@fragments/shared/ExpertHighlightsBlockFragment';
import GalleryBlockFragment from '@fragments/shared/GalleryBlockFragment';
import HeadingBlockFragment from '@fragments/shared/HeadingBlockFragment';
import HtmlBlockFragment from '@fragments/shared/HtmlBlockFragment';
import ImageBlockFragment from '@fragments/shared/ImageBlockFragment';
import PersonBlockFragment from '@fragments/shared/PersonBlockFragment';
import PersonFeedBlockFragment from '@fragments/shared/PersonFeedBlockFragment';
import PullQuoteBlockFragment from '@fragments/shared/PullQuoteBlockFragment';
import RichTextBlockFragment from '@fragments/shared/RichTextBlockFragment';
import SubscribeBlockFragment from '@fragments/shared/SubscribeBlockFragment';
import VideoBlockFragment from '@fragments/shared/VideoBlockFragment';

export default gql`
    fragment StreamTierW100Fragment on W100 {
        columnLayout
        w100___colorScheme: colorScheme
        w100___topPadding: topPadding
        w100___bottomPadding: bottomPadding
        w100___alignment: alignment
        blocks {
            ...AffiliationCardBlockFragment
            ...ButtonBlockFragment
            ...CollectionBlockFragment
            ...ContentCardBlockFragment
            ...ContentFeedBlockFragment
            ...EventPanelBlockFragment
            ...ExpertHighlightsBlockFragment
            ...GalleryBlockFragment
            ...HeadingBlockFragment
            ...HtmlBlockFragment
            ...ImageBlockFragment
            ...PersonBlockFragment
            ...PersonFeedBlockFragment
            ...PullQuoteBlockFragment
            ...RichTextBlockFragment
            ...SubscribeBlockFragment
            ...VideoBlockFragment
        }
        blockName
        blockType
    }
    ${AffiliationCardBlockFragment}
    ${ButtonBlockFragment}
    ${CollectionBlockFragment}
    ${ContentCardBlockFragment}
    ${ContentFeedBlockFragment}
    ${EventPanelBlockFragment}
    ${ExpertHighlightsBlockFragment}
    ${GalleryBlockFragment}
    ${HeadingBlockFragment}
    ${HtmlBlockFragment}
    ${ImageBlockFragment}
    ${PersonBlockFragment}
    ${PersonFeedBlockFragment}
    ${PullQuoteBlockFragment}
    ${RichTextBlockFragment}
    ${SubscribeBlockFragment}
    ${VideoBlockFragment}
`;
